import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/shared/Modal.vue";
import PelLoanOptions from "@/components/pel-loan-configuration/PelLoanOptions.vue";
import PelBorrowAmount from "@/components/pel-loan-configuration/PelBorrowAmount.vue";
import PgLoanOptionsModal from "@/components/professional-grad/PgLoanOptionsModal.vue";
import useApplicationData from "@/composables/useApplicationData";


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanConfigurationModal',
  emits: ["close", "configurationComplete"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const activeStep = ref<number>(1);

const loading = ref<boolean>(true);

const { useProfessionalGradLoanOptionsModal, hasRepaymentBasedRates, isValidProfessionalGradFlow } =
  useApplicationData();

function closeModal() {
  emit("close");
  store.dispatch("applicationInfoModule/closeModal", "PelLoanConfigurationModal");
}

function goBack() {
  if (activeStep.value === 2) {
    activeStep.value -= 1;
  }
}

function complete() {
  if (activeStep.value === 1) {
    borrowAmountComplete();
  } else {
    next();
    emit("configurationComplete");
  }
}

function borrowAmountComplete() {
  next();
}

function next() {
  if (activeStep.value < 2) {
    activeStep.value++;
  }
}

onMounted(async () => {
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(Modal, {
      class: "loan-configuration-modal",
      id: "pel-configuration",
      closeBtn: true,
      onClose: closeModal
    }, {
      default: _withCtx(() => [
        (activeStep.value === 1)
          ? (_openBlock(), _createBlock(PelBorrowAmount, {
              key: 0,
              isCurrent: activeStep.value === 1,
              onClose: closeModal,
              onComplete: complete
            }, null, 8, ["isCurrent"]))
          : _createCommentVNode("", true),
        (activeStep.value === 2 && !_unref(hasRepaymentBasedRates))
          ? (_openBlock(), _createBlock(PelLoanOptions, {
              key: 1,
              isCurrent: activeStep.value === 2,
              loading: loading.value,
              onPrevious: goBack,
              onComplete: complete
            }, null, 8, ["isCurrent", "loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512), [
      [_vShow, 
      (activeStep.value <= 2 && !_unref(useProfessionalGradLoanOptionsModal)) ||
      (_unref(useProfessionalGradLoanOptionsModal) && activeStep.value === 1) ||
      !_unref(hasRepaymentBasedRates)
    ]
    ]),
    (activeStep.value === 2 && _unref(hasRepaymentBasedRates))
      ? (_openBlock(), _createBlock(PgLoanOptionsModal, {
          key: 0,
          ref: "PgLoanOptionsModalRef",
          onConfigurationComplete: complete,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          closeBtn: true
        }, null, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})